// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".duplicates-grid{display:grid;-webkit-box-align:center;-ms-flex-align:center;align-items:center;grid-template-columns:13.2% 9.6% 17.5% 8% 16.4% auto;grid-column-gap:5px}.duplicates-grid.head>div,.duplicates-grid>div{padding-left:1rem;padding-right:1rem}.duplicates-grid.head>div{background-color:var(--border-primary);color:var(--text-text-ternary);border-radius:4px;font-size:1.3rem;padding-top:.75rem;padding-bottom:.75rem}", ""]);
// Exports
module.exports = exports;
